import React, { Component } from 'react'
import AuthService from "../services/AuthService";
import NotificationService from '../services/NotificationService';
import '../css/BisharatMain.css';
import Login from '../pages/Login';
import {ENV_URL} from '../services/Globals';
import { GiBlackFlag } from "react-icons/gi";
import {MdDelete} from "react-icons/md";


import noImagejpg from '../data/images/nothingtoshow.png'
import translate from '../languages/translate';
export class Notifications extends Component {

  state = {
    notifications: [],
    selectedNotification: {},
    authorized: false,
    haveRoleOfAdminOrMod : false,
    search: ''
  }

  componentDidMount() {

    this.refreshNotification();
    this.setState({ selectedNotification: '' });
  }

  refreshNotification = () => {
    const loggedInUser = AuthService.getCurrentUser();
    const whatRole = AuthService.getUserRole();
    if( !loggedInUser || (whatRole === ('USER')) ) {} else {
      this.setState({authorized:true})
      if(whatRole === ('MODERATOR') || whatRole === ('ADMIN')) {
       this.setState({haveRoleOfAdminOrMod : true});
      }
      NotificationService.getAllNotification()
      .then(res => {
        const notifications = res.data;
        this.setState({ notifications });
      })
     }
  }


  deleteNotifClicked(id) {
   
    NotificationService.deletNotification(id)
        .then((response) => {
            window.location.reload();
        })
        .catch((err) => {
        });
}


gotoNotif(id) {
  window.open(`/family-notification/${id}`, '_self');
}


  render() {
    
       return (
      <div className="notifications-main">
        {!this.state.authorized ?
      <div>
        <Login></Login>
        </div> : 
              <div className="boxes-wrapper-for-notif">
          {this.state.notifications.map(notif => (
            <div className="boxes-for-notif" key={notif.id}>
              <GiBlackFlag size={50} color='#538D22'></GiBlackFlag>
              <h2
                onMouseOver={({ target }) => target.style.color = 'black'}
                onMouseOut={({ target }) => target.style.color = '#538D22'}
              >{notif.subject}</h2>
              <p>{notif.content}</p>
              {notif.imageLink ? 

             
              <img className="small-for-notif-details" src={`${ENV_URL}/api/v1/notifications/${notif.id
              }/download`}
              alt="the-notif"/> :
              <img className="small-for-notif-details" src={noImagejpg} alt="nothing-to-show"/>
  }
  <hr></hr>
              <button  onClick={()=>this.gotoNotif(notif.id)} className="btn"> {translate("moredetails")}  </button>
              <br></br>
              {this.state.haveRoleOfAdminOrMod && 
              <MdDelete 
              onClick={() => { if (window.confirm('Are you sure you want to delete this notification?')) this.deleteNotifClicked(notif.id) }} size={40} color="red"/>
              }
            </div>

          ))}
        </div>
    }
      </div>
  

    )
  }
}




export default Notifications;